import styled, { css } from 'styled-components';
import { colors } from 'global/colors';

export const TimeBox = styled.label`
  background-color: ${colors.darkGray};
  margin-left: 1rem !important;
  margin-bottom: 4px;
  padding: 3px 6px;
  display: inline-block;
  font-size: 75%;
  font-weight: bold;
  line-height: 1;
  color: #fff;
  border-radius: 0.25rem;
  cursor: pointer;
`;

export const StatusLabel = styled.label`
  margin-bottom: 2px;
  padding: 5px 10px;
  display: inline-block;
  font-size: 75%;
  font-weight: bold;
  line-height: 1;
  color: #fff;
  border-radius: 0.25rem;
  cursor: pointer;
  ${(props) =>
    props.isProcessing &&
    css`
      background-color: ${colors.fsCyan};
    `}

  ${(props) =>
    props.isStarted &&
    css`
      background-color: ${colors.yellow};
    `}

        ${(props) =>
    props.isNotStarted &&
    css`
      background-color: ${colors.fsDarkBlue};
    `}

            ${(props) =>
    props.isFinished &&
    css`
      background-color: ${colors.green2};
    `}
`;

export const TestSelectContainer = styled.div`
  line-height: 25px;
  width: 100%;
  display: flex;
  align-items: baseline;
`;

export const ProgressBarComponent = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  gap: 2px;
`;

export const ProgressBar = styled.progress`
  display: table-caption;
  height: 20px;
  width: 100%;
  background-color: ${colors.lightGray};
  border: 1px solid ${colors.darkGray};
  box-shadow: 0 0 3px ${colors.darkGray};
  border-style: ridge;
  border-radius: 5px;

  ::-webkit-progress-bar {
    background-color: ${colors.lightGray};
  }

  ::-webkit-progress-value {
    background-color: ${colors.green2};
  }

  ::-moz-progress-bar {
    background-color: ${colors.green2};
  }
`;

export const ResultText = styled.span`
  width: 100%;
  display: block;
  text-align: center;
  color: black;
  position: absolute;
  font-size: 10px;
  top: 2px;
`;

export const TestInformationText = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: #999999;
`;

export const ClearFilterText = styled.div`
  display: flex;
  align-items: left;
  text-decoration: underline;
  font-weight: 600;
  cursor: pointer;
  color: ${colors.darkGray};
  margin-left: 0.75rem;
  margin-right: 0.75rem;
  line-height: 1.5;
`;

export const DateContainer = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  padding: 0 10px;
  color: ${colors.darkGray};
`;

export const DateLabel = styled.label`
  width: 120px;
`;

export const DropdownItem = styled.div`
  padding: 0 10px;
  cursor: pointer;
  color: ${colors.darkGray};
  :hover {
    background-color: ${colors.lightGray};
  }
`;
